// extracted by mini-css-extract-plugin
export default {"root":"ServerError_root__i3FgP","success":"ServerError_success__LNpAM","error":"ServerError_error__ZtT2H"};